export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=61583783867077",
  instagram: "https://www.instagram.com/djdavyne1/",
  youtube: "https://www.youtube.com/@djdavyne5068",
  tiktok: "https://www.tiktok.com/@djdavyne",
};
